export class CopyStopAreaInvalidDateRangeError extends Error {}
